import React from "react";
import { FaChevronLeft } from "react-icons/fa";

import { useNavigate } from "react-router-dom";
function BackButton({ to, label }: any) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="mt-2 ml-2 flex items-center py-2">
      <div className="pr-4 cursor-pointer" onClick={handleClick}>
        <FaChevronLeft className="text-2xl" />
      </div>

      <div className="text-2xl font-semibold text-violet-600">{label}</div>
    </div>
  );
}
export default BackButton;
